var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 81,
      height: 60
    },
    viewBox: "0 0 81 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE9",
    d: "M63.01 59.105H45.844V41.761h5.673c1.438 0 2.288-1.634 1.438-2.811L41.922 23.682a1.758 1.758 0 0 0-2.86 0L28.028 38.95c-.85 1.177-.017 2.811 1.438 2.811h5.672v17.344H15.915C7.333 58.631.5 50.605.5 41.91c0-6 3.253-11.23 8.075-14.058a10.9 10.9 0 0 1-.67-3.81c0-6.13 4.953-11.082 11.083-11.082 1.324 0 2.599.229 3.792.67C26.327 6.109 33.978.895 42.87.895c11.508.016 20.99 8.827 22.068 20.057 8.844 1.52 15.562 9.71 15.562 18.979 0 9.906-7.716 18.488-17.49 19.174"
  })));
};
export default SvgUpload;